import { useModalPromises } from "kreate-common/modules/kreate-ui/components/Modal/hoc/withModalPromises";

import ModalProgress, {
  ModalProgress$Controller,
  ModalProgress$Progress,
} from "..";

export function useModalTrigger$ModalProgress() {
  const { showModal } = useModalPromises();

  const openModal = async function <R>(
    task: (controller: ModalProgress$Controller<R>) => void
  ) {
    return await showModal<R>(({ resolve, reject }) => (
      <ModalProgress open onResolve={resolve} onReject={reject} task={task} />
    ));
  };

  const openModal$AsyncFunction = async function <R>(
    task: (
      controller: Omit<ModalProgress$Controller<R>, "onResolve" | "onReject">
    ) => Promise<R>
  ) {
    return await showModal<R>(({ resolve, reject }) => (
      <ModalProgress
        open
        onResolve={resolve}
        onReject={reject}
        task={async (controller) => {
          try {
            const result = await task(controller);
            controller.resolve(result);
          } catch (error) {
            controller.reject(error);
          }
        }}
      />
    ));
  };

  const openModal$AsyncGenerator = async function <R>(
    task: () => AsyncGenerator<ModalProgress$Progress, R>
  ) {
    return await showModal<R>(({ resolve, reject }) => (
      <ModalProgress
        open
        onResolve={resolve}
        onReject={reject}
        task={async (controller) => {
          try {
            const generator = task();
            while (true) {
              const iter = await generator.next();
              if (iter.done) {
                controller.resolve(iter.value);
                break;
              } else {
                controller.update(iter.value);
              }
            }
          } catch (error) {
            controller.reject(error);
          }
        }}
      />
    ));
  };

  return { openModal, openModal$AsyncFunction, openModal$AsyncGenerator };
}
